

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useFocusEffect, useIsFocused } from '@react-navigation/native';
import { View, KeyboardAvoidingView, VirtualizedList, useWindowDimensions, Pressable, ActivityIndicator, Animated, BackHandler, DeviceEventEmitter, RefreshControl, TouchableOpacity } from 'react-native';
import { Divider } from '@rneui/base';
import Popover from "react-native-popover-view/dist/Popover";
import { appColors, appFonts, fontSize } from '../../themes/appTheme';
import { ThemeConsumer, ThemeOptions } from "@rneui/themed";
import { deleteFilter, deleteOrder, filterProperties, getAllLocations, getAllOrdersList, getSavedFilter, postFilter, LocationWithSelected, OrderType, locationtype, LocationJson, restoreOrder } from '../../redux/slices/orderSlice';
import { config } from '../../shared/environment';
import { getScreenPermission, useAppDispatch, useAppSelector } from '../../redux/hooks';
import CommonService from '../../shared/services/commonService';
import moment from 'moment';
import CommonDialogBox from '../../shared/commonComponents/commonDialogBox';
import { ZenCheckBox, ZenLoader, ZenText, ZenFilterModal, ZenButton, ZenToast, ZenEmptyComponent, ZenIcon, } from 'zen-core-elements';
import { filterItemsProps } from 'zen-core-elements/src/elements/zenFilterModal/zenFilterType.modal'
import { OrderListStyle } from '../../themes/components/order/orderListStyle';
import { useAppNavigation, useAppRoute } from '../../types/@react-navigation/navigation';
import { ListToolbar } from '../../shared/commonComponents/listToolbar';
import { SortOption } from '../../shared/commonComponents/commonSortModal';
import { shallowEqual } from 'react-redux';
import CommonHeader from '../../shared/commonComponents/commonHeader';
import { getOnePostDuplicateCheck } from '../../redux/slices/optionSlice';

export type Filter = {
    paymentstatus?: string | null;
    fullfillmentStatus?: string | null;
    postorderstatus?: string | null;
    shippingtype?: string | null;

    customDate?: {
        startDate: string;
        endDate: string;
    } | null;

    paymentmethod?: string | null;
    ordertype?: string | null;

    pickedUpordeliveryDate?: {
        startDate: string;
        endDate: string;
    } | null;

    savedFilterId?: string | null;
} | null;

export type SavedFilterOption = {
    id: string; filterName: string; filterType: any; filterValue: { value: string; label: string; }[]; initialSelected: string;
}
const limit = 10


const OrderList = () => {
    const navigation: any = useAppNavigation()
    const Route = useAppRoute("OrderList");
    const isRestore = useAppRoute("RestoreOrderList")?.params?.isRestore ?? false;
    const { isWrite: isOrderWrite } = useAppSelector(getScreenPermission("OrdersStack"), shallowEqual)
    const locationData = useAppSelector((state) => state.common?.getStoreLocations)
    let isPos = Route?.params?.isPos || false
    const targetOrdersKey = isPos ? 'posOrders' : 'onlineOrders';
    const { id: locationId } = useAppSelector((state) => state?.common?.currentLocation)

    const { value: listOfOrder, loading: loadPage, count: totalCountOfOrders } = useAppSelector((state) => state?.orderSlice?.[targetOrdersKey])
    let CustomerId = Route?.params?.customerId ?? null;
    const { width } = useWindowDimensions();
    const { isLandscape } = useAppSelector((state) => state?.common)
    const dispatch = useAppDispatch()
    const currencySymbol = useAppSelector((state) => state?.common?.currentUser?.value?.purchasedCurrency?.currencySymbol) ?? '₹'

    const savedFilterDetails = useAppSelector((state) => state?.orderSlice?.getSavedFilter.value?.savedFilters)
    const statusProp = useAppSelector((state) => state?.orderSlice?.filterProperties?.value ? state?.orderSlice?.filterProperties?.value : null)
    const isFocus = useIsFocused()
    const [isInitialLoading, setIsInitialLoading] = useState<boolean>(true)
    const hasFetched = useRef<boolean>(false)
    //Variable to store the selected category items
    const [selectedOrderCard, setSelectedOrderCard] = useState<Set<number>>(new Set([]))
    const [ordersList, setOrdersList] = useState<OrderType[]>([])
    // const [locationList, setLocationList] = useState<locationtype[]>([])
    const [locationList, setLocationList] = useState<any[] | null>(null)

    const [selectedLocation, setSelectedLocation] = useState<locationtype>(null)

    const [deleteAll, setDeleteAll] = useState<boolean>(false)

    const [orderSearch, setOrderSearch] = useState<string | null>(null)

    const [dialogVisible, setDialogVisible] = useState<{ isVisible: boolean, id: number | null }>({ isVisible: false, id: null })
    const [restoreDialogVisible, setRestoreDialogVisible] = useState<{ isVisible: boolean, id: number | null }>({ isVisible: false, id: null })

    const [orderId, setOrderId] = useState<number | number[]>()

    const [filterPayLoad, setFilterPayLoad] = useState<any>(null)

    const [filterVisible, setFilterVisible] = useState(false)

    const [filterName, setFilterName] = useState('')

    const [statusLookup, setStatusLookup] = useState<Record<string, number>>({});
    // variable to store selected location id
    const [selectedLocationId, setSelectedLocationId] = useState<any>(0)
    const [offset, setOffset] = useState<number | null>(null)
    //Variable to control footer loader
    const [footerLoader, setFooterLoader] = useState(false)
    //variable to store the list refresh state
    const [refresh, setRefresh] = useState<boolean>(false)
    //variable to store the count val
    const [count, setCount] = useState<number>(0)

    const [filterData, setFilterData] = useState<filterItemsProps[]>(isPos ?
        [
            { id: '1', filterName: 'Payment Status', filterType: "radio", filterValue: [{ value: 'Paid', label: 'Paid' }, { value: 'UnPaid', label: 'Unpaid' }, { value: 'Partially Paid', label: 'Partially Paid' }, { value: 'Refunded', label: 'Refunded' }, { value: 'Partial refund', label: 'Partial refund' }], initialSelected: '' },
            { id: '2', filterName: 'Fullfillment Status', filterType: "radio", filterValue: [{ value: 'Delivered', label: 'Delivered' }, { value: 'Returned', label: 'Returned', }, { value: 'Partially returned', label: 'Partially returned' }, { value: 'Parked', label: 'Parked' }, { value: 'Parked Return', label: 'Parked Return', }, { value: 'Partially Exchanged', label: 'Partially Exchanged', }, { value: 'Exchanged', label: 'Exchanged', }], initialSelected: '' },
            { id: '5', filterName: 'Payment Method', filterType: "radio", filterValue: [{ value: 'Cash on Delivery', label: 'Cash on Delivery', }, { value: 'Online Payment', label: 'Online Payment', }], initialSelected: '' },
            { id: "6", filterName: "CustomDate", filterType: "dateRange", filterValue: { minDate: "", maxDate: "" }, initialSelected: { startDate: "", endDate: "" } }
        ] :
        [
            { id: '1', filterName: 'Payment Status', filterType: "radio", filterValue: [{ value: 'Paid', label: 'Paid' }, { value: 'Refunded', label: 'Refunded' }, { value: 'UnPaid', label: 'Unpaid' }, { value: 'Cancelled', label: 'Cancelled' }, { value: 'Paid Manually', label: 'Paid Manually' }, { value: 'Authorized', label: 'Authorized' }, { value: 'Cash Refund', label: 'Cash Refund' }, { value: 'Partial refund', label: 'Partial refund' }, { value: 'Created', label: 'Created' }], initialSelected: '' },
            { id: '2', filterName: 'Fullfillment Status', filterType: "radio", filterValue: [{ value: 'New', label: 'New' }, { value: 'Processing', label: 'Processing' }, { value: 'Hold', label: 'Hold' }, { value: 'Packed', label: 'Packed' }, { value: 'Shipped', label: 'Shipped' }, { value: 'Delivered', label: 'Delivered' }, { value: 'Cancelled', label: 'Cancelled' }, { value: 'Picked Up', label: 'Picked Up' }, { value: 'Returned', label: 'Returned' }, { value: 'Partially Returned', label: 'Partially Returned' }, { value: 'Downloaded', label: 'Downloaded' },], initialSelected: '' },
            { id: '3', filterName: 'Payment Method', filterType: "radio", filterValue: [{ value: 'Cash on Delivery', label: 'Cash on Delivery', }, { value: 'Online Payment', label: 'Online Payment', }], initialSelected: '' },
            { id: '4', filterName: 'Shipping Type', filterType: "radio", filterValue: [{ value: 'delivery', label: 'Delivery', }, { value: 'Pickup', label: 'Pickup', }], initialSelected: '' },
            { id: '5', filterName: 'Order Type', filterType: "radio", filterValue: [{ value: 'Manual Order', label: 'Manual Order', }, { value: 'Zenbasket Order', label: 'Zenbasket Order' }, { value: 'Subscription Order', label: 'Subscription Order' }, { value: 'Pre Order', label: 'Pre Order' }, { value: 'Digital Order', label: 'Digital Order', }], initialSelected: '' },
            { id: '6', filterName: "CustomDate", filterType: "dateRange", filterValue: { minDate: "", maxDate: "" }, initialSelected: { startDate: "", endDate: "" } },
            { id: '7', filterName: 'PickedUp Or Delivery Date', filterType: "dateRange", filterValue: { minDate: "", maxDate: "" }, initialSelected: { startDate: "", endDate: "" } }
        ])


    const [filterDeleteId, setFilterDeleteId] = useState<number>(0)

    const [delFilDialog, setfilDialog] = useState(false)

    const [delConfirmation, setDelConfirmation] = useState<{ id: number, name: string } | null>(null)

    const [sortVisible, setSortVisible] = useState(false)


    //variable to store the selected sort
    const [sortOrder, setSortOrder] = useState<{ field: string, order: string, id: number } | null>(null)

    const sortOptionsData: SortOption[] = [
        { name: 'ORDER-ID - Ascending', id: 1, field: "serialOrderId ASC", order: 'ASC' },
        { name: 'ORDER-ID - Descending', id: 2, field: "serialOrderId DESC", order: 'DESC' },
        { name: 'Total Amount : Low to High', id: 3, field: "totalAmount ASC", order: 'DESC' },
        { name: 'Total Amount : High to Low', id: 4, field: "totalAmount DESC", order: 'ASC' },
        { name: 'Recently Ordered First', id: 5, field: "createdAt DESC", order: 'DESC' },
        { name: 'Recently Ordered Last', id: 6, field: "createdAt ASC", order: 'ASC' },
        { name: 'Recently Updated First', id: 7, field: 'modifiedAt DESC', order: 'DESC' },
        { name: 'Recently Updated Last', id: 8, field: 'modifiedAt ASC', order: 'ASC' }
    ]

    const [sortKey, setSortkey] = useState<string | null>(null)

    const fadeUp = useRef(new Animated.Value(0)).current

    const fadeDown = useRef(new Animated.Value(0)).current

    // const filterKey =
    // {
    //     ORDER_STATUS: isPos ? "POS_ORDER_STATUS" : "ORDER_STATUS",
    //     PAYMENT_STATUS: isPos ? "POS_PAYMENT_STATUS" : "PAYMENT_STATUS"
    // }

    const restoreDialogProps = {
        content: 'Are you sure you want to restore this order? ',
        button: [{ id: 1, name: 'Yes', color: appColors.primary, backgroundColor: appColors.light }, { id: 2, name: 'No', color: appColors.light, backgroundColor: appColors.primary }],
    }

    // Method which is used for restore confirmation
    const restoreConfirmation = (value: { name: String }) => {
        if (value?.name == 'No') {
            setRestoreDialogVisible(prev => ({ ...prev, isVisible: false }))
        }
        else {
            setRestoreDialogVisible(prev => ({ ...prev, isVisible: false }))
            restoreOrderApi()
        }
    }

    useEffect(() => {

        let addAttributes: any[] = []
        listOfOrder?.map((val) => {
            addAttributes.push({ ...val, selectedList: false })
        })
        setOrdersList(addAttributes)
    }, [listOfOrder])

    const reInitializeStates = () => {
        DeviceEventEmitter?.emit("orderListFilter")
        setFilterPayLoad(null)
        setSelectedLocationId(null)
        setSelectedLocation(null)
        setOrderSearch(null)
        setSortkey(null)
        setRefresh(true)
        setSelectedOrderCard(new Set([]))
        toggleOffset()
    }

    const locationUpdation = (selectedLocation: LocationWithSelected) => {
        setLocationList((prev) => {
            if (!prev) return null
            return prev?.map((item) => ({
                ...item,
                selected: item.id == selectedLocation.id
            }))
        })
    }
    useEffect(() => {
        if (locationData?.value?.length) {
            const addFlag = locationData?.value.map((item: any) => ({
                ...item,
                selected: false
            }));
            const defaultLocation = {
                id: 1,
                locationName: 'All Location',
                addressId: 0,
                isActive: true,
                isDefault: false,
                medium: '',
                selected: true,
                timeZone: '',
            };
            setLocationList([defaultLocation, ...addFlag])
        }
    }, [locationData]);

    useEffect(() => {
        const orderCardUpdate = DeviceEventEmitter.addListener("ORDERS_UPDATED", (data: any) => {
            if (data?.isPos === isPos) {
                reInitializeStates()
            }
        })
        return () => {
            orderCardUpdate?.remove()
        }
    }, [isPos])

    const toggleOffset = () => {
        setOffset((prev) => prev === 0 ? -1 : 0)
    }


    useFocusEffect(
        useCallback(() => {
            if (isFocus) {
                if (ordersList.length === 0 && !hasFetched.current) {
                    hasFetched.current = true;
                    setIsInitialLoading(true);
                    const promises: Promise<any>[] = [];
                    if (!isRestore) {
                        promises.push(getAllInvLocations());
                        promises.push(filterFullfillmentProp());
                    }

                    promises.push(getAllOrderList(true));
                    Promise.all(promises).finally(() => {
                        setIsInitialLoading(false);
                    });
                } else {
                    setIsInitialLoading(false);
                }
            }
        }, [isFocus, isRestore])
    );

    useEffect(() => {
        if (offset != null) {
            getAllOrderList()
        }
    }, [offset])

    //useEffect which gets triggered when search changes
    useEffect(() => {
        if (orderSearch != null) {
            const searchDebounceFunction = setTimeout(() => {
                toggleOffset()
            }, 1000)
            return () => clearTimeout(searchDebounceFunction)
        }
    }, [orderSearch]);

    //useEffect to handle filter selection
    useEffect(() => {
        if (filterPayLoad != null) {
            if (filterName) {
                addFilter(filterName, filterPayLoad)
            }
            else {
                toggleOffset()
            }
        }
    }, [filterPayLoad])

    useEffect(() => {
        if (delConfirmation && delFilDialog) {
            if (delConfirmation.id == 2) {
                deleteSavedFilter(filterDeleteId)
                setDelConfirmation(null)
            }
            else {
                setfilDialog(false)
                setDelConfirmation(null)
            }
        }
    }, [delConfirmation])

    useEffect(() => {
        if (filterDeleteId) {
            setfilDialog(true)
        }
    }, [filterName, filterDeleteId])

    useEffect(() => {
        if (!sortVisible && sortKey != null) {
            toggleOffset()
            setSortVisible(false)
        }
    }, [sortKey])

    const filterOut = useMemo(() => {
        return ordersList.filter((i) => i.selectedList == true)
    }, [ordersList])

    const formatFilterValue = (title: string, value: string) => {
        if (!value) return "-";
        if (
            title === "CustomDate" ||
            title === "PickedUp Or Delivery Date"
        ) {
            // value expected as "startDate,endDate" OR ISO strings
            if (value.includes(",")) {
                const [start, end] = value.split(",");
                return `${start} - ${end}`;
            }
        }

        return value;
    };

    const enableDeleteIcon = useMemo(() => {
        return filterOut.length ? true : false
    }, [filterOut])

    const fadeAnimation = useCallback(() => {
        Animated.timing(enableDeleteIcon ? fadeUp : fadeDown,
            {
                toValue: 1,
                useNativeDriver: true,
                duration: 500
            }
        ).start()
    }, [enableDeleteIcon])

    useEffect(() => {
        if (enableDeleteIcon) {
            fadeAnimation()
        }
        else {
            fadeUp.setValue(0)
        }
    }, [enableDeleteIcon])

    const orderTypeHelper = useCallback((type: string) => {
        if (type) {
            let existType = ['Zenbasket Order', 'Manual Order', 'Subscription Order', 'Pre Order', 'Digital Order']
            let keys = ['isZen', 'isManualOrder', 'isSubscription', 'isPreOrder', 'isDigitalOrder']
            let orderTypeData: { [key: string]: boolean | null } = {};
            existType.map((i, index) => {
                if (type === i) {
                    orderTypeData[keys[index]] = true
                }
            })
            return orderTypeData
        }
    }, [])

    const addFilter = useCallback(async (filterName: string, savedFilters: Array<{ Title: string; Value: any }>) => {
        if (!filterName || !savedFilters?.length) return;

        const savedFilterNames = savedFilters.map(({ Title, Value }) => ({ Title, Value: String(Value), }));

        const filterPredicate: any = { customDateRange: {}, deliveryDate: {}, };
        savedFilters.forEach(({ Title, Value }) => {
            if (!Value) return;

            switch (Title) {
                case "Payment Status": {
                    filterPredicate.status = Value;
                    break;
                }

                case "Fullfillment Status": {
                    const id = statusLookup[Value];
                    if (id) filterPredicate.value = id;
                    break;
                }

                case "Post FullFillment Status": {
                    const id = statusLookup[Value];
                    if (id) filterPredicate.postOrderStatus = id;
                    break;
                }

                case "Shipping Type": {
                    filterPredicate.deliveryType =
                        Value.toLowerCase() === "delivery" ? "DELIVERY" : "PICKUP";
                    break;
                }

                case "Payment Method": {
                    filterPredicate.paymentMethod =
                        Value.toLowerCase() === "cash on delivery" ? "0" : "1";
                    break;
                }

                case "Order Type": {
                    filterPredicate.orderType = orderTypeHelper(Value);
                    break;
                }

                case "CustomDate": {
                    filterPredicate.customDateRange = {
                        begin: Value?.startDate ?? null,
                        end: Value?.endDate ?? null,
                    };
                    break;
                }

                case "PickedUp Or Delivery Date": {
                    filterPredicate.deliveryDate = {
                        begin: Value?.startDate ?? null,
                        end: Value?.endDate ?? null,
                    };
                    break;
                }

                default:
                    break;
            }
        });
        const payload = {
            storeId: config.storeId,
            code: "ORDER_FILTER",
            filterName,
            filterPredicate,
            savedFilterNames,
        };

        try {
            await dispatch(postFilter({ storeId: config.storeId, data: payload, })).unwrap();
            setFilterName("");
            SavedFilter();
        } catch (err) {
            console.log("addFilter error", err);
        }
    },
        [statusLookup, orderTypeHelper, dispatch]
    );

    const SavedFilter = useCallback(async () => {
        try {
            const response = await dispatch(getSavedFilter({ storeId: config.storeId, data: { code: 'ORDER_FILTER' } })).unwrap();

            if (!response?.savedFilters) return;
            setFilterData(prev => {
                let updated = [...prev];

                const savedFilterObj: SavedFilterOption = {
                    id: '8',
                    filterName: 'Saved Filters',
                    filterType: 'savedFilters',
                    filterValue: response.savedFilters.map(item => ({
                        value: String(item.id),
                        label: item.filterName
                    })),
                    initialSelected: ''
                };

                const index = updated.findIndex(i => i.id === '8');
                if (index !== -1) {
                    updated[index] = savedFilterObj;
                } else {
                    updated.push(savedFilterObj);
                }
                return updated;
            });

            setFilterDeleteId(0);
            setfilDialog(false);

        } catch (err) {
            console.log("error in getSavedFilter", err);
        }
    }, [dispatch, config.storeId]);

    const buildBackendFilterPayload = (entries: { Title: string; Value: string }[], filterData: any) => {
        const payload: any = {};

        entries.forEach(({ Title, Value }) => {
            switch (Title) {
                case "Payment Status":
                    payload.status = Value;
                    break;

                case "Shipping Type":
                    payload.deliveryType =
                        Value.toLowerCase() === "delivery" ? "DELIVERY" : "PICKUP";
                    break;

                case "Payment Method":
                    payload.paymentMethod =
                        Value.toLowerCase() === "cash on delivery" ? "0" : "1";
                    break;

                case "Fullfillment Status": {
                    const statusItem = filterData?.find((f: any) => f.filterName === "Fullfillment Status");
                    const match = statusItem?.content?.find((c: any) => c.nameofcontent === Value);
                    if (match) payload.value = Number(match.id);
                    break;
                }

                case "CustomDate": {
                    payload.customDateRange = Value;
                    break;
                }

                case "PickedUp Or Delivery Date": {
                    payload.deliveryDate = Value;
                    break;
                }

                default:
                    break;
            }
        });

        return payload;
    };
    const savedFilterPayloadHelper = useCallback((savedData: { Title: string; Value: string }[], filterData: any) => {
        return buildBackendFilterPayload(savedData, filterData);
    },
        []
    );

    const deleteSavedFilter = useCallback(async (filterId: number) => {
        await dispatch(deleteFilter({ storeId: config.storeId, filterId: filterId })).unwrap().then((response) => {
            if (response) {
                SavedFilter()
            }
        }).catch((err) => {
            console.log("err in deleteSavedFilter", err);
        })
    }, [filterDeleteId])

    const restoreOrderApi = async () => {
        await dispatch(restoreOrder({ storeId: config.storeId, orderId: restoreDialogVisible?.id!, isPos })).unwrap().then((response) => {
            if (response) {
                navigation.goBack()
                ZenToast({ message: "The order has been successfully restored", type: "success" })
            }
        }).catch((err) => {
            console.log("err in restoreOrderApi", err);
        })
    }

    const getAllInvLocations = useCallback(() => {
        return dispatch(getAllLocations({ storeId: config.storeId })).unwrap().then((res: LocationJson) => {
            if (res) {
                let addingAttributes = [...res?.inventoryLocation ? res?.inventoryLocation : []]
                let att = { id: 0, locationName: 'All location' }
                addingAttributes.push(att)
                addingAttributes = addingAttributes.map((i) => {
                    if (i) {
                        let newItem = { ...i }; // Spread into a new object to avoid mutating the original
                        newItem.search = true; // Add the search property
                        if (newItem.id == 0) {
                            setSelectedLocation(newItem); // Set the selected location for the custom item
                            newItem.selected = true;
                        } else {
                            newItem.selected = false;
                        }
                        return newItem; // Return the new object
                    }
                    return i;
                });
                setLocationList(addingAttributes)
                return SavedFilter()
            }
        }).catch((err) => {
            console.log(err);
        })
    }, [config.storeId])



    const filterFullfillmentProp = async () => {
        const codes = isPos
            ? ["POS_ORDER_STATUS", "POS_PAYMENT_STATUS", "POST_ORDER_STATUS"]
            : ["ORDER_STATUS", "PAYMENT_STATUS"];

        const response = await dispatch(
            filterProperties({ data: { code: JSON.stringify(codes) } })
        ).unwrap();
        const lookup: Record<string, number> = {};

        response.propertyValueData.forEach((group) => {
            group.propertyValues.forEach((item) => {
                if (item.value != undefined)
                    lookup[item.value.trim()] = item.id;
            });
        });
        setStatusLookup(lookup);
    };

    const getAllOrderList = (isTabFocus = false) => {
        let isFilter: any = {}
        if (filterPayLoad) {
            if (filterPayLoad?.savedFilterId) {
                let findKey = savedFilterDetails?.filter((i) => i.id == filterPayLoad?.savedFilterId)
                if (findKey?.length) {
                    let payload = savedFilterPayloadHelper(findKey[0]?.savedFilterNames, filterData)
                    isFilter = payload
                }
            }
            else {
                if (filterPayLoad?.paymentstatus) {
                    isFilter.status = filterPayLoad.paymentstatus
                }
                if (filterPayLoad?.fullfillmentStatus) {
                    const id = statusLookup[filterPayLoad.fullfillmentStatus];
                    if (id) isFilter.value = id;
                }
                if (filterPayLoad?.postorderstatus) {
                    isFilter.postOrderStatus = filterPayLoad.postorderstatus
                }
                if (filterPayLoad?.paymentmethod) {
                    isFilter.paymentMethod = filterPayLoad.paymentmethod == 'cash on delivery' ? "0" : "1"
                }
                if (filterPayLoad?.shippingtype) {
                    isFilter.deliveryType = filterPayLoad.shippingtype == 'delivery' ? "DELIVERY" : "PICKUP"
                }
                if (filterPayLoad?.customDate) {
                    isFilter.customDateRange = filterPayLoad?.customDate
                }
                if (filterPayLoad?.pickedUpordeliveryDate) {
                    isFilter.deliveryDate = filterPayLoad?.pickedUpordeliveryDate
                }
                if (filterPayLoad?.ordertype) {
                    isFilter.orderType = orderTypeHelper(filterPayLoad?.ordertype) ? orderTypeHelper(filterPayLoad?.ordertype) : []
                }
            }
        }

        const data = {
            locationId: locationId ?? 0,/* locId !== undefined ? locId : (selectedLocationId ?? 0) */
            limit: limit,
            offset: offset == -1 ? 0 : offset || 0,
            filterData: Object.keys(isFilter || {}).length
                ? JSON.stringify(isFilter)
                : JSON.stringify({}),
            searchValue: orderSearch ? orderSearch.trim() : "",
            sortOrder: sortKey ? JSON.stringify(sortKey) : "",
            customerId: CustomerId ? CustomerId : null,
            ...isRestore && { restore: isRestore, }
        }

        if (deleteAll) {
            setDeleteAll(false)
        }

        // Optimization: Avoid redundant API call on tab focus if we already have data
        // the cached list is unfiltered, so always fetch when filtering by customer
        if (isTabFocus && listOfOrder?.length > 0 && !refresh && !isRestore && !CustomerId) {
            return Promise.resolve();
        }

        return dispatch(getAllOrdersList({ storeId: config.storeId, data: data, isPos: isPos })).unwrap().then((res) => {
        }).catch((err) => {
            console.log("err in getAllOrdersList", err);
        }).finally(() => {
            setFooterLoader(false)
            setRefresh(false)
        })

    }

    const toggleSelect = (id: number) => {
        setSelectedOrderCard(prev => {
            const next = new Set(prev)
            next.has(id) ? next.delete(id) : next.add(id)
            return next
        })

    }

    const onLongPress = (categoryData: OrderType) => {
        if (!isLandscape && selectedOrderCard.size === 0) {
            toggleSelect(categoryData.id)
        }
    }
    const onPress = (categoryData: OrderType) => {
        if (!isLandscape && selectedOrderCard.size > 0) {
            toggleSelect(categoryData.id)
        }
    }

    const deleteSingleOrBulkOrder = () => {
        const ids = orderId ? (Array.isArray(orderId) ? orderId : [orderId]) : Array.from(selectedOrderCard)
        let data = { storeId: config?.storeId, orderId: JSON.stringify(ids) }
        dispatch(deleteOrder({ storeId: config.storeId, orderId: { orderId: JSON.stringify(ids) } })).unwrap().then((deleteRes) => {

            if (deleteRes) {
                ZenToast({ type: "success", message: "Order(s) deleted successfully" })
                setOrdersList((prev) => prev.filter((order) => !ids.includes(order.id)));
                setSelectedOrderCard(new Set([]))
                setOrderId(undefined)
                toggleOffset()
            }
        }).catch(() => {
            ZenToast({ type: "error", message: "Error in bulk delete" })
        })
    }


    const confirmation = (item: { id: number }) => {
        if (item?.id == 2) {
            deleteSingleOrBulkOrder()
            setDialogVisible({ isVisible: false, id: null })
        } else {
            setDialogVisible({ isVisible: false, id: null })
            setOrderId(undefined)
        }
    }

    const helpOrder = useCallback((values: OrderType): string | null => {
        const keys = ['isZen', 'isManualOrder', 'isSubscription', 'isPreOrder', 'isDigitalOrder'] as const;
        const orderKeys = ['zenbasketOrder', 'manualorder', 'subscriptionOrder', 'pre-order', 'digitalorder'];

        let result: string | null = null;
        // Iterate over the keys of the values object
        (Object.keys(values) as Array<keyof OrderType>).forEach((keyValues) => {
            keys.map((findKey, ind) => {
                if (findKey === keyValues && values[keyValues]) {
                    result = orderKeys[ind];
                }
            });
        });
        return result;
    }, []);

    const helpOrderColor = useCallback((orderType: string | null) => {
        let colors: { bgColor: string, textColor: string } = { bgColor: '', textColor: appColors?.light }
        switch (orderType) {
            case 'zenbasketOrder':
                colors.bgColor = appColors?.wildPink
                break;
            case 'manualorder':
                colors.bgColor = appColors?.darkGreen
                break;
            case 'subscriptionOrder':
                colors.bgColor = appColors?.wildPink
                break;
            case 'pre-order':
                colors.bgColor = appColors?.lightYellow
                colors.textColor = appColors?.dark
                break;
            case 'digitalorder':
                colors.bgColor = appColors?.lightPrimary
                colors.textColor = appColors?.dark
                break;
            default:
                colors.bgColor = appColors?.primary
                break
        }
        return colors

    }, [])

    const renderItem = ({ item, index }: { item: OrderType, index: number }) => (
        <ThemeConsumer>
            {({ theme }) => renderOrderItemContent(item, index, theme)}
        </ThemeConsumer>
    );

    const getPremiumBadgeColors = (type: string | null) => {
        switch (type) {
            case 'zenbasketOrder':
                return { bgColor: '#FCE7F3', dotColor: '#EC4899', textColor: '#9D174D' };
            case 'manualorder':
                return { bgColor: '#DCFCE7', dotColor: '#22C55E', textColor: '#15803D' };
            case 'subscriptionOrder':
                return { bgColor: '#F3E8FF', dotColor: '#A855F7', textColor: '#6B21A8' };
            case 'pre-order':
                return { bgColor: '#FEF3C7', dotColor: '#F59E0B', textColor: '#92400E' };
            case 'digitalorder':
                return { bgColor: '#E0F2FE', dotColor: '#0EA5E9', textColor: '#0369A1' };
            default:
                return { bgColor: '#F1F5F9', dotColor: '#64748B', textColor: '#334155' };
        }
    };

    const renderOrderItemContent = (item: OrderType, index: number, theme: ThemeOptions) => {
        const orderType = helpOrder(item);

        return (
            <ThemeConsumer>
                {({ theme }) => (
                    <TouchableOpacity disabled={isLandscape} onLongPress={() => onLongPress(item)} onPress={() => onPress(item)} style={{
                        padding: 10,
                        borderRadius: 16,
                        marginBottom: 10,
                        marginHorizontal: 10,
                        shadowColor: '#0F172A',
                        shadowOffset: { width: 0, height: 2 },
                        shadowOpacity: 0.05,
                        shadowRadius: 8,
                        elevation: 2, backgroundColor: theme.light, borderWidth: !isLandscape && selectedOrderCard?.has(item?.id) ? 1.5 : 0, borderColor: appColors.lightDark,
                    }}>
                        {/* HEADER ROW */}
                        <View style={OrderListStyle.headerRow}>
                            <View style={OrderListStyle.headerLeft}>
                                {isLandscape && isOrderWrite && !isRestore && (
                                    <View style={{ width: 30 }}>
                                        <ZenCheckBox
                                            checked={selectedOrderCard?.has(item?.id)}
                                            size={22}
                                            checkedColor={appColors.primary}
                                            onPress={() => {
                                                toggleSelect(item.id)
                                            }}
                                        />
                                    </View>
                                )}
                                <View style={OrderListStyle.headerTexts}>
                                    <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                                        <ZenText
                                            content={item.customizedOrderId}
                                            bold
                                            size={theme.smallerFontSize}
                                            color={appColors.lightDark}
                                            style={OrderListStyle.headerOrderId}
                                        />

                                        <ZenText
                                            content={moment(item.createdAt).format("DD/MM/YYYY - hh:mm A")}
                                            size={theme.errorFontSize}
                                            color={appColors.grey}
                                            style={OrderListStyle.headerDate}
                                        />
                                        {/* BADGES ROW */}
                                        <View style={OrderListStyle.badgesRow}>
                                            <View style={[OrderListStyle.customBadge, { backgroundColor: '#EFF6FF' }]}>
                                                <ZenText
                                                    content={isPos ? `POS ${item.locationId}` : item?.locationId}
                                                    bold
                                                    size={theme.errorFontSize}
                                                    color="#1E40AF"
                                                />
                                            </View>

                                            {orderType && (() => {
                                                const premiumColors = getPremiumBadgeColors(orderType);
                                                return (
                                                    <View style={[OrderListStyle.customBadge, { backgroundColor: premiumColors.bgColor }]}>
                                                        <View style={[OrderListStyle.customBadgeDot, { backgroundColor: premiumColors.dotColor }]} />
                                                        <ZenText
                                                            content={orderType.replace("-", " ")}
                                                            bold
                                                            size={theme.errorFontSize}
                                                            color={premiumColors.textColor}
                                                            style={{ textTransform: 'capitalize' }}
                                                        />
                                                    </View>
                                                );
                                            })()}
                                        </View>
                                    </View>

                                </View>
                            </View>

                            <View style={OrderListStyle.headerRightActions}>
                                {!isRestore && <TouchableOpacity
                                    style={OrderListStyle.actionCircleButton}
                                    onPress={() =>
                                        navigation.navigate("OrderDetails", {
                                            orderId: item.id,
                                            isPos: isPos
                                        })
                                    }
                                >
                                    <ZenIcon
                                        name="eye-outline"
                                        type="material-community"
                                        size={18}
                                        color={appColors.lightDark}
                                    />
                                </TouchableOpacity>}
                                {selectedOrderCard?.size <= 0 && isOrderWrite && !isRestore &&
                                    <TouchableOpacity
                                        style={OrderListStyle.actionDeleteCircleButton}
                                        onPress={() => {
                                            setDialogVisible({ isVisible: true, id: item?.id });
                                            setOrderId(item.id);
                                            // toggleSelect(item?.id)
                                        }}
                                    >
                                        <ZenIcon
                                            name="delete-outline"
                                            type="material-community"
                                            size={18}
                                            color={appColors.red}
                                        />
                                    </TouchableOpacity>
                                }
                                {isRestore && isOrderWrite && <TouchableOpacity
                                    style={OrderListStyle.actionCircleButton}
                                    onPress={() => setRestoreDialogVisible({ isVisible: true, id: item?.id })}
                                >
                                    <ZenIcon
                                        name="history"
                                        type="octicon"
                                        size={18}
                                        color={appColors.lightDark}
                                    />
                                </TouchableOpacity>}
                            </View>
                        </View>

                        {/* DIVIDER */}
                        <Divider style={OrderListStyle.cardDivider} />

                        {/* GRID BODY */}
                        <View style={OrderListStyle.gridContainer}>
                            {/* CUSTOMER */}
                            <View style={[OrderListStyle.gridItem, { width: isLandscape ? '33.33%' : '50%', marginBottom: 10, }]}>
                                <View style={[OrderListStyle.gridItemIconContainer]}>
                                    <ZenIcon
                                        name="account-outline"
                                        type="material-community"
                                        size={12}
                                        color={appColors.primary}
                                    />
                                </View>
                                <View style={OrderListStyle.gridItemTextContainer}>
                                    <ZenText
                                        content="Customer Name : "
                                        bold
                                        size={theme.errorFontSize}
                                        color={appColors.grey}
                                        style={{ textTransform: "uppercase", marginTop: 2 }}

                                    />
                                    <ZenText
                                        content={`${item.userFirstName ?? ""} ${item.userLastName ?? ""}`.trim() || "-"}
                                        bold
                                        size={theme.smallFontSize}
                                        color={appColors.lightDark}
                                    />
                                </View>
                            </View>

                            {/* PHONE */}
                            <View style={[OrderListStyle.gridItem, { width: isLandscape ? '33.33%' : '50%', marginBottom: 10, }]}>
                                <View style={OrderListStyle.gridItemIconContainer}>
                                    <ZenIcon
                                        name="phone-outline"
                                        type="material-community"
                                        size={12}
                                        color={appColors.primary}
                                    />
                                </View>
                                <View style={OrderListStyle.gridItemTextContainer}>
                                    <ZenText
                                        content="Phone No : "
                                        bold
                                        size={theme.errorFontSize}
                                        color={appColors.grey}
                                        style={{ textTransform: "uppercase", marginTop: 2 }}
                                    />
                                    <ZenText
                                        content={item.userPhone || "-"}
                                        bold
                                        size={theme.smallFontSize}
                                        color={appColors.lightDark}
                                    />
                                </View>
                            </View>

                            {/* PAYMENT STATUS */}
                            <View style={[OrderListStyle.gridItem, { width: isLandscape ? '33.33%' : '50%', marginBottom: 10, }]}>
                                <View style={[OrderListStyle.gridItemIconContainer, { backgroundColor: '#EFF6FF' }]}>
                                    <ZenIcon
                                        name="credit-card-outline"
                                        type="material-community"
                                        size={12}
                                        color="#2563EB"
                                    />
                                </View>
                                <View style={OrderListStyle.gridItemTextContainer}>
                                    <ZenText
                                        content="Payment : "
                                        bold
                                        size={theme.errorFontSize}
                                        color={appColors.grey}
                                        style={{ textTransform: "uppercase", marginTop: 2 }}
                                    />
                                    <ZenText
                                        content={item.paymentStatus || "-"}
                                        bold
                                        size={theme.smallFontSize}
                                        color="#2563EB"
                                    />
                                </View>
                            </View>

                            {/* ORDER STATUS */}
                            <View style={[OrderListStyle.gridItem, { width: isLandscape ? '33.33%' : '50%' }]}>
                                <View style={[OrderListStyle.gridItemIconContainer, { backgroundColor: '#ECFDF5' }]}>
                                    <ZenIcon
                                        name="shield-check-outline"
                                        type="material-community"
                                        size={12}
                                        color="#16A34A"
                                    />
                                </View>
                                <View style={OrderListStyle.gridItemTextContainer}>
                                    <ZenText
                                        content="Order Status : "
                                        bold
                                        size={theme.errorFontSize}
                                        color={appColors.grey}
                                        style={{ textTransform: "uppercase", marginTop: 2 }}
                                    />
                                    <ZenText
                                        content={item.orderStatus === "Pending" ? "Parked Return" : item.orderStatus || "-"}
                                        bold
                                        size={theme.smallFontSize}
                                        color="#16A34A"
                                    />
                                </View>
                            </View>

                            {/* TOTAL AMOUNT */}
                            <View style={[OrderListStyle.gridItem, { width: isLandscape ? '33.33%' : '50%' }]}>
                                <View style={[OrderListStyle.gridItemIconContainer, { backgroundColor: '#F1F5F9' }]}>
                                    <ZenIcon
                                        name="currency-usd"
                                        type="material-community"
                                        size={12}
                                        color="#0F172A"
                                    />
                                </View>
                                <View style={OrderListStyle.gridItemTextContainer}>
                                    <ZenText
                                        content="Total Amount : "
                                        bold
                                        size={theme.errorFontSize}
                                        color={appColors.grey}
                                        style={{ textTransform: "uppercase", marginTop: 2 }}
                                    />
                                    <ZenText
                                        content={`${CommonService.currencyStandard(currencySymbol, String(item.totalAmount ?? 0))}`}
                                        bold
                                        size={theme.smallFontSize}
                                        color="#0F172A"
                                    />
                                </View>
                            </View>

                            {/* SHIPMENT */}
                            <View style={[OrderListStyle.gridItem, { width: isLandscape ? '33.33%' : '50%' }]}>
                                <View style={[OrderListStyle.gridItemIconContainer, { backgroundColor: '#ECFDF5' }]}>
                                    <ZenIcon
                                        name="truck-delivery-outline"
                                        type="material-community"
                                        size={12}
                                        color="#16A34A"
                                    />
                                </View>
                                <View style={OrderListStyle.gridItemTextContainer}>
                                    <ZenText
                                        content="Shipment Type : "
                                        bold
                                        size={theme.errorFontSize}
                                        color={appColors.grey}
                                        style={{ textTransform: "uppercase", marginTop: 2 }}
                                    />
                                    <ZenText
                                        content={item.shippingType || "-"}
                                        bold
                                        size={theme.smallFontSize}
                                        color="#16A34A"
                                    />
                                </View>
                            </View>
                        </View>
                    </TouchableOpacity>
                )}
            </ThemeConsumer>

        );
    };

    const footerComponent = () => {
        return (
            <ThemeConsumer>
                {({ theme }) => (
                    footerLoader ?
                        <View style={{}} >
                            <ActivityIndicator size={"small"} color={theme?.primary} />
                        </View >
                        : undefined
                )}
            </ThemeConsumer>
        )
    }

    const onEndReached = () => {
        let offsetValue = offset && offset != -1 ? offset : 0
        if (!footerLoader && (totalCountOfOrders!! > offsetValue)) {
            setFooterLoader(true)
            setOffset(offsetValue + limit)
        }
    };

    const onRefresh = () => {
        setRefresh(true)
        reInitializeStates()
    }


    const checkDuplicates = async (value: string) => {
        let result = { isDuplicate: false, loader: false }
        await dispatch(getOnePostDuplicateCheck({ storeId: config.storeId, data: { columnName: 'filterName', id: null, tableName: 'savedFilters', value: value, storeId: true } })).unwrap().then((res) => {
            if (res.result) {
                result.isDuplicate = res?.result?.alreadyExists
                result.loader = false
            }
        }).catch((err) => {
            console.log("err in checkDuplicates for filter", err);
        })
        return result
    }

    return (
        <ThemeConsumer>
            {({ theme }: any) => (
                <KeyboardAvoidingView style={{ flex: 1, backgroundColor: "#f8f8f8" }}>
                    <View style={{ flex: 1 }}>
                        {isRestore && <CommonHeader backIcon={true} backIconOnpress={() => navigation.goBack()} headerName='Restore Order' />}
                        <ListToolbar
                            search={{
                                value: orderSearch || "",
                                onChange: (val) => { setOrderSearch(val as string) },
                                onCancel: () => setOrderSearch(null),
                                placeholder: 'Search by order',
                            }}
                            // location={{
                            //     label: selectedLocation ? selectedLocation.locationName : 'All Location',
                            //     locationList: locationList,
                            //     title: 'Select Location',
                            //     onSelect: (item) => {
                            //         setSelectedLocation(item as LocationWithSelected);
                            //         locationUpdation(item as LocationWithSelected);
                            //         setSelectedLocationId(item?.id)
                            //         toggleOffset()
                            //     },
                            // }}
                            sort={{
                                selectedId: sortOrder?.id,
                                onSelect: (item) => {
                                    setSortOrder(item as { field: string, order: string, id: number });
                                    setSortkey(item?.field!!)
                                },
                                title: 'Sort by',
                                options: sortOptionsData

                            }}
                            filter={{
                                count: count ?? 0,
                                onPress: () => setFilterVisible(true),
                            }}
                            buttons={!isRestore && isPos ? [{ title: "Restore", onPress: () => { navigation.navigate("RestoreOrderList", { isRestore: true, isPos: true }); hasFetched.current = false } }] : []}
                        />
                        {(isInitialLoading || (loadPage && !refresh && !footerLoader)) ?
                            <ZenLoader lottie={require('../../assets/infinityLoader.json')} lottieType='Local' viewStyle={{ backgroundColor: "transparent" }} /> :
                            <View style={{ flex: 1 }}>
                                <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between", paddingHorizontal: 10, display: selectedOrderCard?.size ? "flex" : "none", paddingBottom: 10 }}              >
                                    <ZenCheckBox
                                        title={selectedOrderCard?.size === listOfOrder?.length ? "Deselect All" : "Select All"}
                                        containerStyle={{ margin: 0, padding: 0, backgroundColor: "transparent", }}
                                        titleStyle={{ fontSize: theme?.mediumFontSize }}
                                        checkedColor={theme.primary}
                                        size={20}
                                        checked={selectedOrderCard?.size === listOfOrder?.length}
                                        onPress={() => {
                                            if (selectedOrderCard?.size === listOfOrder?.length) {
                                                // Deselect All
                                                setSelectedOrderCard(new Set())
                                            }
                                            else {
                                                // Select All
                                                const allIds = new Set<number>()
                                                listOfOrder?.forEach(card =>
                                                    allIds.add(card.id)
                                                )
                                                setSelectedOrderCard(allIds)
                                            }
                                        }}
                                    />
                                    {isLandscape &&
                                        <ZenButton
                                            title="Delete"
                                            titleStyle={{
                                                fontSize: fontSize.errorFontSize,
                                                fontFamily: appFonts.bold,
                                                color: appColors.red,
                                            }}
                                            onPress={() => {
                                                if (selectedOrderCard?.size > 0) {
                                                    setOrderId(undefined);
                                                    setDialogVisible({ id: null, isVisible: true });
                                                } else {
                                                    ZenToast({
                                                        type: "info",
                                                        message: "Choose at least one order to remove",
                                                    });
                                                }
                                            }}
                                            buttonStyle={{
                                                height: 38,
                                                paddingHorizontal: 5,
                                                borderRadius: 10,
                                                backgroundColor: "#FEF2F2",
                                                borderWidth: 1,
                                                borderColor: "#FECACA",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                marginBottom: 10,
                                                // iOS shadow
                                                shadowColor: "#EF4444",
                                                shadowOffset: { width: 0, height: 2 },
                                                shadowOpacity: 0.08,
                                                shadowRadius: 4,

                                                // Android
                                                elevation: 1,
                                            }}
                                        />
                                    }

                                </View>
                                {/* )} */}

                                <VirtualizedList
                                    keyExtractor={(_: any, index: number) => index?.toString()}
                                    getItemCount={(data: any) => data?.length}
                                    getItem={(data, index) => { return data[index] }}
                                    scrollEnabled={true}
                                    nestedScrollEnabled={true}
                                    renderItem={renderItem}
                                    data={ordersList || []}
                                    keyboardDismissMode="on-drag"
                                    showsVerticalScrollIndicator={false}
                                    onEndReachedThreshold={0.01}
                                    contentContainerStyle={[{ paddingBottom: ordersList?.length ? 10 : undefined, flexGrow: ordersList?.length ? undefined : 1 }]}
                                    ListFooterComponent={footerComponent}
                                    ListFooterComponentStyle={{ height: ordersList?.length ? 70 : 0 }}
                                    ListEmptyComponent={<ZenEmptyComponent viewStyle={{ backgroundColor: theme?.light }} />}
                                    onEndReached={onEndReached}
                                    refreshControl={<RefreshControl refreshing={refresh} onRefresh={onRefresh} />}
                                />
                            </View>
                        }
                    </View>



                    <ZenFilterModal
                        savedFilterDetails={savedFilterDetails}
                        checkduplicate={checkDuplicates}
                        filterName='orderListFilter'
                        key={filterData.length}
                        setVisible={setFilterVisible}
                        visible={filterVisible}
                        filterItems={filterData}
                        filterCount={count}
                        setFilterCount={setCount}
                        setFilterItems={setFilterData}
                        onSaveConfirm={(data) => {
                            addFilter(data?.saveFilterName, data?.savedFilterItems)
                        }}

                        onConfirm={(val) => {
                            let data: Filter = {}
                            const values = val?.values;
                            if (values?.["Payment Status"]) {
                                data.paymentstatus = values["Payment Status"];
                            }

                            if (values?.["Fullfillment Status"]) {
                                data.fullfillmentStatus = values["Fullfillment Status"];
                            }

                            if (values?.["Post FullFillment Status"]) {
                                data.postorderstatus = values["Post FullFillment Status"];
                            }

                            if (values?.["Shipping Type"]) {
                                data.shippingtype = values["Shipping Type"];
                            }

                            if (values?.["Payment Method"]) {
                                data.paymentmethod = values["Payment Method"]
                            }

                            if (values?.["Order Type"]) {
                                data.ordertype = values["Order Type"]
                            }

                            if (values?.["CustomDate"]?.startDate) {
                                data.customDate = values["CustomDate"];
                            }
                            if (values?.["PickedUp Or Delivery Date"]) {
                                data.pickedUpordeliveryDate = values["PickedUp Or Delivery Date"]
                            }
                            if (values?.["Saved Filters"]) {
                                data.savedFilterId = values["Saved Filters"];
                            }
                            setFilterPayLoad(data);
                        }}


                        title="Orders List Filter" />
                    {
                        !isLandscape && (
                            <View>
                                {
                                    selectedOrderCard?.size > 0 &&
                                    <View style={OrderListStyle?.deleteIconView2}>
                                        <ZenIcon
                                            name="delete-outline"
                                            type={"material-community"}
                                            size={30}
                                            color={appColors.light}
                                            onPress={() => { selectedOrderCard?.size > 0 ? (setOrderId(undefined), setDialogVisible({ isVisible: true, id: null })) : ZenToast({ type: "info", message: "Choose at least one order to remove", }) }}
                                        />
                                    </View>
                                }
                            </View>
                        )}

                    <Popover isVisible={dialogVisible?.isVisible} popoverStyle={{ width: width >= 600 ? 'auto' : width - 50 }}>
                        <CommonDialogBox type={'DELETE'} replaceValue='order' confirmation={confirmation} />
                    </Popover>
                    <Popover isVisible={restoreDialogVisible?.isVisible} popoverStyle={{ width: width > 900 ? 500 : width > 600 ? 450 : 350, borderRadius: 10 }}>
                        <CommonDialogBox type="OTHER" dialog={restoreDialogProps} confirmation={restoreConfirmation} />
                    </Popover>
                    <Popover isVisible={delFilDialog}>
                        <CommonDialogBox type={'DELETE'} confirmation={setDelConfirmation} replaceValue='filter' />
                    </Popover>
                </KeyboardAvoidingView>
            )
            }
        </ThemeConsumer >
    )

}
export default React.memo(OrderList)
